module.exports = __webpack_public_path__ + "static/tiefling_male_SCAG-9e9970f61f45af6e217a7eb1967f8fe0.png";